export enum EventCategories {
  UI = `UI`,
}
